import { useGetMyExamCentersQuery } from '@exam-center/graphql';
import { getStorageItem } from '@shared/utils';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

interface UseGetExamCenterInformationOptions {
  userId?: string;
}

export function useGetExamCenterInformation(options?: UseGetExamCenterInformationOptions) {
  const { userId } = options ?? {};
  const { examCenterCode } = useParams<{ examCenterCode: string }>();

  const localStorageExamCenterCode = getStorageItem<string>('examCenterCode');

  const { data, loading: isLoading } = useGetMyExamCentersQuery({
    skip: !userId,
  });

  const examCentersData = data?.ecGetMyExamCenters.examCenters ?? [];

  // NOTE: we need to sort the exam centers by examCenterId for displaying
  const examCenters = [...examCentersData].sort((a, b) => a.examCenterId - b.examCenterId);

  const currentExamCenter = useMemo(() => {
    const examCenterFromUrl = examCenters.find(
      (examCenter) =>
        examCenter.code.toLowerCase() === examCenterCode?.toLowerCase() &&
        !location.pathname.startsWith('/admin'),
    );

    const examCenterFromLocalStorage = examCenters.find(
      (examCenter) => examCenter.code.toLowerCase() === localStorageExamCenterCode?.toLowerCase(),
    );

    return examCenterFromUrl ?? examCenterFromLocalStorage ?? examCenters?.[0];
  }, [examCenterCode, localStorageExamCenterCode, examCenters, location.pathname]);

  return {
    examCenters,
    currentExamCenter,
    loading: isLoading,
  };
}
